import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { isNullOrUndefined } from 'util';
import { Theme } from '../../decorators/theme.decorator';
import { MatAutocompleteTrigger } from '@angular/material';

/**
 * Created by gbray on 16/05/2017.
 */

@Component({
  selector: 'sc-auto-complete-component',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.css']
})
export class AutoCompleteFragment implements OnInit, AfterViewInit {
  @Theme() public theme: string;
  @Input() public model: any;
  @Input() public focus: boolean;
  @Input() public fieldToDisplay: string;
  @Input() public suggestions: any[];
  @Input() public control: FormControl;
  @Input() public placeholder: string; // define a placeholder
  @Input() public required = false; // if required is true, '*' is added in the placeholder
  @Input() public width = '100%';
  @Input() public min = 0;
  @Input() public debounceDelay = 0;
  @Input() public id = '';
  @Input() public appearance = 'standard';
  @Input() public color = 'primary';
  @Input() public hint = '';
  @Input() public error = '';
  public timeoutID: any;
  @Input() public ordered = false;

  @Input() public priorOptionSelected = false;

  // output called to load the suggestions of a auto complete field
  @Output() public autoCompleteGenericEmitter = new EventEmitter();
  // output called when a suggestion is selected in a auto complete field
  @Output() public autoCompleteOnSelectGenericEmitter = new EventEmitter();
  // To prevent an angular material bug when it comes to remove then select back an autocomplete's element.
  // in Legal, we privilege this event rather than the 'OnSelect' shit.
  @Output() public autoCompleteOptionSelectedGenericEmitter = new EventEmitter();
  // output called to check type value
  @Output() public autoCompleteBlurEmitter = new EventEmitter();
  // output called to check type value
  @Output() public autoCompleteClickEmitter = new EventEmitter();

  @Output() public onModelChangeEmitter = new EventEmitter();
  @ViewChild('autoCompleteInputField', { static: false }) public el: ElementRef;
  @ViewChild('autoCompleteInputField', { static: false })
  public trigger: MatAutocompleteTrigger;
  @ViewChild('auto', { static: false }) public auto: ElementRef;

  constructor(private rd: Renderer2) {}

  public ngOnInit(): void {}

  public ngAfterViewInit() {
    if (!isNullOrUndefined(this.focus) && this.focus) {
      this.el.nativeElement.focus();
    }
  }

  /**
   * Search by throwing a autoCompleteGenericEmitter to the calling template or component.
   * The search is character by character if no debounceDelay specified,
   * When debounceDelay is reached else.
   *
   */
  public search(event) {
    // if no debounceDelay, send a request for each character of the input field.
    if (this.debounceDelay === 0) {
      this.doSearch(event);
      return;
    }

    // if debounceDelay asked, we setUp a timeout on the EventEmitter
    this.debounceEventEmitter(event);
  }

  public debounceEventEmitter(event) {
    if (this.timeoutID) {
      window.clearTimeout(this.timeoutID);
    }
    this.timeoutID = window.setTimeout(() => {
      this.doSearch(event);
    }, this.debounceDelay);
  }

  public doSearch(event): void {
    if (event.target.value.length >= this.min) {
      this.autoCompleteGenericEmitter.emit(event);
    } else if (event.target.value.length === 0) {
      const id = this.id;
      this.onModelChangeEmitter.emit({ event, id });
    }
  }

  public onSelect(suggestion) {
    this.autoCompleteOnSelectGenericEmitter.emit(suggestion);
  }

  public onInputAutoCompleteBlur(event) {
    this.autoCompleteBlurEmitter.emit(event);
  }

  public onInputAutoCompleteClick(event) {
    this.autoCompleteClickEmitter.emit(event);
  }

  optionSelectedValue(event) {
    this.autoCompleteOptionSelectedGenericEmitter.emit(event);
  }
}
